import React from 'react';
import {isEmpty} from '../../inc/Helpers';
const MenuFooter = (props) =>{

    const {purchasePrice, status, icons, customSiteWidget} = props;

    if (!isEmpty(customSiteWidget)) {
        return (
            <div className="menu-footer d-none d-lg-block">
                <div dangerouslySetInnerHTML={{__html: customSiteWidget}}/>
            </div>
        )
    }

    if (!isEmpty(purchasePrice) || !isEmpty(status) || !isEmpty(icons)) {
        return (
            <div className='menu-footer d-none d-lg-block'>
                Status: {status}
                <br/>
                <h3 className='widget-price'>{purchasePrice}</h3>
                <hr className="mt-0"/>
                <MenuFooterIcons icons={icons}/>
            </div>
        )
    }
return null;
}

export default MenuFooter;

const MenuFooterIcons = ({icons}) => {

    if (!icons) {
        return null;
    }

    return (<div className="social-media-icons" style={{marginRight: '-9px',marginBottom: '-14px'}}>
        {icons.map(function (icon, index) {
            let className = icon[0] + " fa-lg social_icon mr-3 mb-4";
            return (
                <a href={icon[1]} target="_blank" key={index}>
                    <i className={className}></i>
                </a>
            )
        })}
    </div>);
}

